import { Driver } from 'scenes/motor/types';

export const hasName = (driver: Driver): boolean =>
  Boolean(driver.firstName && driver.lastName);
